import ProductModel from '../Product'
import styles from './styles.css'

const VisibleProductModel = props => {
  return (
    <ProductModel
      okText='隱藏商品'
      className='visible-prodcut-modal'
      {...props}
    >
      <p className={styles.row}>項目隱藏後，復原需重新提案，</p>
      <p className={styles.row}>你確定要從此賣場上隱藏該項目？</p>
      <br />
      <span className={styles.tip}>
        此項目商品將不顯示在此賣場上，
        <br />
        並不影響其他賣場之顯示，也並未從此賣場移除綁定
      </span>
    </ProductModel>
  )
}

export default VisibleProductModel
